import * as React from 'react';
import Text from '../Text';
import './style.scss';
import classNames from 'classnames';
import NavigationGroup, {
  NavigationItem as NavigationItemType,
} from '../NavigationGroup';
import { useTranslation } from 'react-i18next';
import LanguageGroup from '../NavigationGroup/language-group';
import { AvailableLanguages } from '../../utils/langaugeTypes';

interface Props {
  id: string;
  language: AvailableLanguages;
  href?: string;
  textId: string;
  isCurrent?: boolean;
  linkClassName: string;
  variant?: string;
  pages?: NavigationItemType[];
  isOnTop: boolean;
  icon?: React.ReactNode;
}

const LanguageNavigationItem: React.FC<Props> = ({
  id,
  pages,
  language,
  href,
  textId,
  isCurrent,
  linkClassName,
  icon,
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = React.useState(false);

  const onClickNavigation = React.useCallback(
    () => setIsOpen((state) => !state),
    []
  );

  return (
    <div onClick={onClickNavigation} className="navigation-menu__menu__wrapper">
      <div
        className={classNames('navigation-menu__menu__pages__item', {
          'nav-collapse': pages,
          'nav-collapse--light': pages && linkClassName === 'dark-mode',
          open: isOpen,
        })}
        key={id + language}
      >
        <Text
          type="label"
          color={linkClassName === 'dark-mode' ? 'light' : 'dark'}
          weight="bold"
          href={href}
          linkClassName={linkClassName}
          className={classNames(
            'h6',
            `navigation-menu__menu__pages__item--${
              linkClassName === 'dark-mode' ? 'light' : 'dark'
            }`,
            { current: isCurrent },
            !!icon && 'navigation-menu__menu__pages__item--with-icon'
          )}
          id={textId}
        >
          {icon}
          <span className="navigation-menu__menu__pages__item__text">
            {language.toUpperCase()}
          </span>
        </Text>
        {pages && (
          <div
            className={classNames('navigation-list', {
              'navigation-list--open': isOpen,
            })}
          >
            <LanguageGroup items={pages} language={language} />
          </div>
        )}
      </div>
    </div>
  );
};

export default LanguageNavigationItem;
